/** Permission roles for workspace access control. */
export var WorkspacePermission = /*#__PURE__*/function (WorkspacePermission) {
  WorkspacePermission["PatientRead"] = "WORKSPACE_PATIENT_READ";
  WorkspacePermission["PatientWrite"] = "WORKSPACE_PATIENT_WRITE";
  WorkspacePermission["PatientUpload"] = "WORKSPACE_PATIENT_UPLOAD";
  return WorkspacePermission;
}({});